import or from 'occamsrazor';

const events = (() => {
  if (typeof window !== 'undefined' && window.TES && window.TES.events) {
    return window.TES.events;
  }

  return or.registry('tes')('events');
})();

export const isUserLoggedIn = () => typeof window !== 'undefined' && document.cookie.indexOf('TESCookieUser=') !== -1;

export class AuthHelper {
  constructor(trackTask, task) {
    this.trackTask = trackTask;
    this.task = task;
  }

  listenForLogin() {
    events.on('logged-in', () => this.task());
    return events.on('modal-close', 'authapp', () => true);
  }

  run() {
    try {
      this.trackTask();

      if (isUserLoggedIn()) {
        this.task();
        return;
      }

      events.one('modal-ready', events.trigger('auth-open', 'sign-in', false));
      this.listenForLogin();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error when logging in', error);
    }
  }
}
